import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ProposalState from "../constants/ProposalState";
import { GigProposal } from "../interfaces/Gig";

export interface createGigProposalState {
  gigProposal: GigProposal;
}

const initialState: createGigProposalState = {
  gigProposal: {
    overview: "",
    chefUid: "",
    clientUid: "",
    proposalState: ProposalState.DRAFT,
    gigId: "",
  },
};

export const createGigProposalSlice = createSlice({
  name: "createGigProposal",
  initialState,
  reducers: {
    setGigProposal: (state, action: PayloadAction<GigProposal>) => {
      state.gigProposal = action.payload;
    },
    resetGigProposalState: () => initialState,
  },
});

export const { setGigProposal, resetGigProposalState } =
  createGigProposalSlice.actions;

export default createGigProposalSlice.reducer;
